import React from 'react';
import { VenueCard } from './ui.jsx';
import { needsAccount } from './gate.jsx';
import { track } from './track.js';

/* ═══════════════════════════════════════════════════════════════════════════
 * ZARYNA'S CARD ON A BOOKING QUESTION — 20 October 2026.
 *
 * Al-Noor, after a friend in Calgary asked her to book First Street Market and
 * was told to "follow the steps": "I don't love that it's giving me
 * instructions on how to do something, when I asked it to do it for me."
 * She now says what is true (walk-in / online / by phone) and the card carries
 * the action, one tap away:
 *   online → "Reserve a Table" (the venue page's own button and words, the same
 *            ?reserve= screen, the same sign-in gate)
 *   phone  → the number, as the venue page's Contact row dials it
 *   walk-in / not known → nothing; her sentence is the answer.
 * The card itself is an <a>, so the button sits UNDER it — an anchor inside an
 * anchor is invalid markup a browser repairs by splitting the card.
 * ═══════════════════════════════════════════════════════════════════════════ */
export function BookingCard({ v, tab, reason = null }) {
  const card = <VenueCard v={v} tab={tab} reason={reason} />;
  if (v.booking === 'online') {
    return (
      <div className="zbook">
        {card}
        <a className="reserveWide" href={`?reserve=${encodeURIComponent(v.id)}`}
          onClick={(ev) => { if (needsAccount('reserve', { ret: ev.currentTarget.getAttribute('href') })) ev.preventDefault(); }}>
          Reserve a Table
        </a>
      </div>
    );
  }
  if (v.booking === 'phone' && v.phone) {
    return (
      <div className="zbook">
        {card}
        <a className="reserveWide" href={`tel:${String(v.phone).replace(/\s+/g, '')}`}
          onClick={() => track('call_tapped', { restaurant_id: v.id, source_screen: 'zaryna' })}>
          {v.phone}
        </a>
      </div>
    );
  }
  return card;
}

/* a booking answer carries its own buttons, so the line telling people to tap
   a restaurant is not drawn under it */
export function isBookingAnswer(cards) {
  return Array.isArray(cards) && cards.some((c) => c && c.booking !== undefined);
}
